import { Component } from '@angular/core';

@Component({
  selector: 'mobi-login-callback',
  standalone: true,
  template: '',
})
export class LoginCallbackComponent {}
